<template>
    <v-layout align-center class="zoom">
        <div @click="zoomOut" class="minus">
            <img src="/img/scenario/zoom-out.svg"/>
        </div>
        <v-menu offset-y>
            <template v-slot:activator="{ on }">
                <div class="level" v-on="on">{{ value }}%</div>
            </template>
            <div class="fci-list">
                <div class="fci-list-item" @click="selectZoom(20)">20%</div>
                <div class="fci-list-item" @click="selectZoom(50)">50%</div>
                <div class="fci-list-item" @click="selectZoom(100)">100%</div>
                <div class="fci-list-item" @click="selectZoom(150)">150%</div>
                <div class="fci-list-item" @click="selectZoom(200)">200%</div>
            </div>
        </v-menu>
        <div @click="zoomIn" class="plus">
            <img src="/img/scenario/zoom-in.svg"/>
        </div>
    </v-layout>
</template>

<script>
import { AppEventBus, AppEventBusType } from '@/eventbus/app.eventbus'

export default {
    name: 'ZoomButton',
    data () {
        return {
            value: 100
        }
    },
    mounted () {
        AppEventBus.on(AppEventBusType.ZOOM, this.setZoomValue)
    },
    destroyed () {
        AppEventBus.off(AppEventBusType.ZOOM, this.setZoomValue)
    },
    methods: {
        setZoomValue (zoom) {
            this.value = zoom
        },
        zoomIn () {
            AppEventBus.emit(AppEventBusType.ZOOM_IN)
        },
        zoomOut () {
            AppEventBus.emit(AppEventBusType.ZOOM_OUT)
        },
        selectZoom (zoom) {
            AppEventBus.emit(AppEventBusType.ZOOM, zoom)
        }
    }
}
</script>

<style scoped lang="scss">
.zoom {
    background: #fff;
    flex-grow: 0;
    border: 1px solid #EDEDF2;
    border-radius: 5px;
    height: 38px;

    .minus {
        border-right: 1px solid #EDEDF2;
        width: 38px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
            background: #e5e5e5;
        }
    }

    .plus {
        border-left: 1px solid #EDEDF2;
        width: 38px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
            background: #e5e5e5;
        }
    }

    .level {
        height: 100%;
        width: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        cursor: pointer;
        user-select: none;

        &:hover {
            background: #e5e5e5;
        }
    }

    img {
        width: 16px;
        height: 16px;
        user-select: none;
    }

    i {
        user-select: none;
    }
}
</style>
